import {
  apiURL
} from '../../config/app';

const getDoctors = async ({ authToken }) => {
  const response = await fetch(`${apiURL}/users/doctors`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    }
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

const createInterventions = async ({ payload, authToken }) => {
  const response = await fetch(`${apiURL}/interventions`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    body: JSON.stringify(payload)
  })
  if (!response.ok)
    throw await response.json()
  
  return response.json();
};

export default {
  getDoctors,
  createInterventions
};



// WEBPACK FOOTER //
// ./api/interventions.js